// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card--19GQ1","Tag":"Tag--3VdB-"};